<template>
  <div>
    <div :class="['portrait', {'collapse':isCollapse}]">
      <div :class="['portrait-img-content', {'portrait-img-content-margin':isCollapse}]">
        <el-image
          :class="['portrait-img', {'portrait-img-collapse':isCollapse}]"
          :src="pic_path"
          fit="fill"
          @click="gotoAccountSetting"
        />
      </div>
      <div :class="['portrait-name', {'portrait-name-collapse':isCollapse}]">
        <div style="height: 100%; display: flex; align-items: center">
          <el-tooltip
            :disabled="mainUserName.length < 25"
            placement="top"
            effect="light"
          >
            <div slot="content">{{ mainUserName }}</div>
            <p v-if="mainUserName.length >= 25" class="name-text">{{ mainUserName }}</p>
            <p v-else>{{ mainUserName }}</p>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MerchantPortrait',
  data() {
    return {
      pic_path: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'mainUserName'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  mounted() {
    this.getMchLogo()
  },
  watch: {
    '$store.state.user.userInfo': {
      handler: function () {
        this.getMchLogo()
      },
      deep: true
    }
  },
  methods: {
    gotoAccountSetting() {
      this.$router.push('/systemManage/settings')
    },
    getMchLogo() {
      let logoImgOssUrl = this.$store.getters.logoImgOssUrl
      if(logoImgOssUrl) {
        this.pic_path = logoImgOssUrl
      }
    }
  }
}
</script>

<style scoped>
  .portrait {
    height: 120px;
    font-style: normal;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */
    color: #1A3465;

  }

  .collapse {
    display: none;
    /*height: 80px !important;*/
  }

  .portrait-img-content-margin {
    margin-left: 2px !important;
  }

  .portrait-img-collapse {
    width: 60px !important;
    height: 60px !important;
  }

  .portrait-img-content {
    padding-top: 20px;
    margin-left: 20px;
    display: inline-block;
    vertical-align: top;
  }

  .portrait-img {
    width:80px;
    height: 80px;
    cursor: pointer;
    border: 1px solid #c0ccda;
    border-radius: 50%;
  }

  .portrait-name {
    width: 140px;
    height:120px;
    margin-left: 10px;
    display: inline-block;
    overflow: hidden;
  }
  .portrait-name:after{
    content:'';
    width:0;
    height:100%;
    display:inline-block;
    vertical-align:middle;
  }
  .name-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    line-height: 22px;
    max-height: 44px;
  }

  .portrait-name-collapse {
    display: none;
  }
</style>
